import { Navigate, useLocation } from 'react-router-dom';

import { ROUTES } from '@/_navigation/routes';

export default function RedirectResolver() {
  const { search } = useLocation();

  return <Navigate to={`${ROUTES.QUALIFY.link}${search}`} />;
}
